import { TransactionView } from "../../../../models/view/transaction/transaction.view";
import { GeneratedCollection } from "../../generated.collection.abstraction";
import { inject, signal, Signal, WritableSignal } from "@angular/core";
import { LogService } from "@bitwarden/common/abstractions/log.service";
import { Observable } from "rxjs";
import { toObservable } from "@angular/core/rxjs-interop";
import { RevalMetaData } from "@bitwarden/web-vault/app/models/types/revaluation.types";
import { RevaluationWorkerService } from "@bitwarden/web-vault/app/services/web-worker/revaluation/revaluation.worker.service";

export class RevaluationTransactionsGeneratedCollection extends GeneratedCollection<TransactionView> {
  /** Bumped by clear(). clear() can't cancel a setRevals() that is already awaiting the worker
   * (e.g. logout mid-refresh), so setRevals() captures this before its await and drops the
   * worker's result if a clear landed meanwhile, instead of writing the previous session's revals
   * into the cleared collection. Same pattern as BalanceAlignmentTransactionsGeneratedCollection. */
  private epoch = 0;
  protected log: LogService = inject(LogService);
  protected generatedTransactions: TransactionView[] = [];
  protected _collection: WritableSignal<TransactionView[]> = signal<TransactionView[]>(null);
  collection: Signal<TransactionView[]> = this._collection.asReadonly();
  collection$: Observable<TransactionView[]> = toObservable(this.collection);

  update(transactions: TransactionView[]): void {
    this.generatedTransactions = transactions;
    this._collection.set(this.generatedTransactions);
  }

  clear(): void {
    this.epoch++;
    this._collection.set(null);
  }

  async setRevals(revalMetaData: RevalMetaData) {
    const epoch = this.epoch;
    /** @Sinan do we need to cast back to TransactionView? OR is TransactionViewObject is fine? */
    const revals = await new RevaluationWorkerService().getRevaluations(revalMetaData);
    if (epoch !== this.epoch) {
      this.log.info("Revaluation finished after a clear — discarding stale result");
      return;
    }
    this._collection.set(revals);
  }
}
